<div style="padding: 20px 22px; min-width: 360px; max-width: 480px;">
  <div class="flex items-center gap-2 mb-3">
    <div style="display: inline-flex; align-items: center; justify-content: center; width: 36px; height: 36px; background: #fef3c7; border-radius: 50%;">
      <mat-icon style="font-size: 22px; width: 22px; height: 22px; color: #d97706;">warning</mat-icon>
    </div>
    <h2 style="font-size: 1rem; font-weight: 800; color: #1f2937; margin: 0;">Eliminar país</h2>
  </div>

  <p style="font-size: 0.85rem; color: #374151; margin: 0 0 8px 0; line-height: 1.5;">
    Vas a quitar <strong style="color: #1e5a3f;">{{ data.countryName }}</strong>
    <span style="font-family: monospace; font-size: 0.8rem; background: #f3f4f6; padding: 1px 6px; border-radius: 4px; margin: 0 2px;">{{ data.countryCode }}</span>
    del whitelist. No se podrán realizar <strong>payouts</strong> a este país.
  </p>
  <p style="font-size: 0.8rem; color: #6b7280; margin: 0 0 16px 0; line-height: 1.5;">
    Si querés volver a habilitarlo, tenés que agregarlo de nuevo desde la lista
    de países disponibles en Vita.
  </p>

  <div class="flex justify-end gap-2">
    <button type="button" (click)="cancel()"
      style="padding: 8px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 600; font-size: 0.85rem; cursor: pointer;"
      onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='white'">
      Cancelar
    </button>
    <button type="button" (click)="confirm()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #dc2626; color: white; border: none; border-radius: 8px; font-weight: 700; font-size: 0.85rem; cursor: pointer;"
      onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px;">delete</mat-icon>
      Eliminar
    </button>
  </div>
</div>
